import React, { useState } from 'react'

import styles from './ModalCard.module.scss'
import TimezoneRadioSelect from '../RadioSelect/TimezoneRadioSelect'
import { ReactComponent as Close } from '../../../../assets/svgs/close.svg'
import { ReactComponent as Search } from '../../../../assets/svgs/search.svg'
import { H4 } from '../../../../components/UI'
import I18n from 'i18n-js'
import { useSelector } from 'react-redux'

const TimezoneModalCard = (props) => {
	const [value, setValue] = useState('')
	const { handleClose } = props
	const {
		timezones
	} = useSelector(state => state.SettingsReducer)
	let timezonesFilter=timezones.filter((tmz=>{
		const t = tmz.timezone.toLowerCase().split('/')

		return `${t[0]} ${t[1]} ${t[0]} - ${t[1]} ${t[0]}-${t[1]}`.indexOf(value.toLowerCase()) !== -1;
	}))


	return (
		<div>
			<div>
				<div className={styles.Header}>
					<p className={styles.title}>{I18n.t('settings.timezoneTitle')}</p>
					<div className={styles.close} onClick={handleClose}>
						<Close/>
					</div>
				</div>
				<H4>{I18n.t('settings.timezoneDescription')}</H4>
				<div className={styles.inputContainer}>
					<Search className={styles.searchIcon}/>
					<input
						type="search"
						value={value}
						onChange={e => setValue(e.target.value.substr(0,20))}
						placeholder={I18n.t('settings.timezoneSearch')}
						className={styles.input}/>
				</div>
				<div>
					{/*{value.length>0 && timezone.map(tmz=>(*/}
					{/*	if(tmz.timezone ===value){*/}
					{/*		*/}
					{/*}*/}
					{/*))}*/}

				</div>
				<TimezoneRadioSelect handleClose={props.handleClose} timezones={timezonesFilter}/>
			</div>
		</div>
	)
}

export default TimezoneModalCard
